import React, { useState, useEffect, useRef } from "react";
import axios from '../../api/axios';
import { useAuth } from '../../context/AuthProvider';
import { useNavigate, Link } from "react-router-dom";
import './User.css';

const UserTwoFactor = () => {
  const { auth, loading } = useAuth();
  const [formData, setFormData] = useState({ name: "", username: "", email: "", password: "" });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const [showOTPField, setShowOTPField] = useState(false);
  const [qrCode, setQrCode] = useState("");
  const [secret, setSecret] = useState("");
  const [twoFAType, setTwoFAType] = useState("");
  const [enabling, setEnabling] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [disabling, setDisabling] = useState(false);
  const [regeneratingBackup, setRegeneratingBackup] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);
  const [resending, setResending] = useState(false);
  const prevTwoFAType = useRef(twoFAType); // track previous
  const [emailResendTimer, setEmailResendTimer] = useState(0);
  const [appQrCode, setAppQrCode] = useState("");
  const [appSecret, setAppSecret] = useState("");
  
  const [showEmailOTPField, setShowEmailOTPField] = useState(false);
  const [showAppOTPField, setShowAppOTPField] = useState(false);

const isEmailOtpFlow = twoFAType === "email" && showEmailOTPField;
const isAppOtpFlow = twoFAType === "app" && showAppOTPField && !!appQrCode;






useEffect(() => {
  console.log("📦 Initializing 2FA Type:", twoFAType);

  if (auth.user && twoFAType === "") {
    const initialType = auth.user.twoFactorMethod || (auth.user.email ? "email" : "app");
    setTwoFAType(initialType);
  }
}, [auth.user, twoFAType]);

useEffect(() => {
  if (isEmailOtpFlow && resendTimer > 0) {
    const interval = setInterval(() => {
      setEmailResendTimer(t => t - 1);
    }, 1000);
    return () => clearInterval(interval);
  }
}, [isEmailOtpFlow, emailResendTimer]);

  
useEffect(() => {
  // If leaving email and it's mid-flow, preserve
  if (
    prevTwoFAType.current === "email" &&
    twoFAType !== "email" &&
    showEmailOTPField &&
    emailResendTimer > 0
  ) {
    prevTwoFAType.current = twoFAType;
    return;
  }
  // If leaving app and it's mid-flow, preserve
  if (
    prevTwoFAType.current === "app" &&
    twoFAType !== "app" &&
    showAppOTPField &&
    !!appQrCode // app-based flow is active if showAppOTPField && appQrCode exists
  ) {
    prevTwoFAType.current = twoFAType;
    return;
  }
  // If switching *to* email mid-flow, preserve
  if (
    twoFAType === "email" &&
    showEmailOTPField &&
    emailResendTimer > 0
  ) {
    prevTwoFAType.current = twoFAType;
    return;
  }
  // If switching *to* app mid-flow, preserve
  if (
    twoFAType === "app" &&
    showAppOTPField &&
    !!appQrCode
  ) {
    prevTwoFAType.current = twoFAType;
    return;
  }
  // Otherwise reset as normal
  reset2FAFlow();
  prevTwoFAType.current = twoFAType;
  // eslint-disable-next-line
}, [twoFAType]);







useEffect(() => {
  if (resendTimer > 0) {
    const interval = setInterval(() => {
      setResendTimer(t => t - 1);
    }, 1000);
    return () => clearInterval(interval);
  }
}, [resendTimer]);

function reset2FAFlow() {
  setShowEmailOTPField(false);
  setShowAppOTPField(false);
  setAppQrCode("");
  setAppSecret("");
  setOtpDigits(["", "", "", "", "", ""]);
  setErrorMessage("");
  setSuccessMessage("");
  setEmailResendTimer(0);
}




  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const otp = otpDigits.join(""); // Combine for backend submission


  const [confirmPassword, setConfirmPassword] = useState(""); // ✅ New state


  const [password, setPassword] = useState("");
  const [showBackupRegeneration, setShowBackupRegeneration] = useState(false);

  const [disable2FAPassword, setDisable2FAPassword] = useState("");
  const [showDisable2FAPasswordField, setShowDisable2FAPasswordField] = useState(false);



  const navigate = useNavigate();

  useEffect(() => {
    if (auth.user) {
      setFormData({ 
        name: auth.user.name, 
        username: auth.user.username || "", 
        email: auth.user.email, 
        password: "" 
      });

      setTwoFactorEnabled(auth.user.twofactorRequired);

      // ✅ FIX HERE:
      if (auth.user.twoFactorMethod) {
        setTwoFAType(auth.user.twoFactorMethod);
      } else if (auth.user.email) {
        setTwoFAType("email");
      } else {
        setTwoFAType("app");
      }
    }
  }, [auth.user]);


  


const enable2FA = async () => {
  setErrorMessage("");
  setSuccessMessage("");
  setEnabling(true);

  try {
    const csrfToken = document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];

    if (!csrfToken) {
      setEnabling(false);
      setErrorMessage("Failed to enable 2FA due to security validation.");
      return;
    }

    let res;
    if (twoFAType === "email") {
      res = await axios.post("/api/2fa/send-2fa-email", {}, {
        withCredentials: true,
        headers: { "x-csrf-token": csrfToken }
      });
      setShowEmailOTPField(true);
      setResendTimer(30); // ← not setEmailResendTimer!
      setEnabling(false); // <-- No timeout, immediately stop spinner!
    } else {
      res = await axios.post("/api/2fa/enable-2fa", { email: formData.email }, {
        withCredentials: true,
        headers: { "x-csrf-token": csrfToken }
      });
      setAppQrCode(res.data.qrCode);
      setAppSecret(res.data.secret);
      setShowAppOTPField(true);
      setEnabling(false); // <-- Same, you can keep it direct!
    }
  } catch (error) {
    setEnabling(false);
    setErrorMessage(error.response?.data?.error || "Failed to enable 2FA.");
  }
};



const handleOtpChange = (value, index) => {
  if (!/^\d?$/.test(value)) return;
  const updatedDigits = [...otpDigits];
  updatedDigits[index] = value;
  setOtpDigits(updatedDigits);

  if (value && index < 5) {
    document.getElementById(`otp-${index + 1}`).focus();
  }
};

const handleOtpPaste = (e) => {
  e.preventDefault();
  const pasteData = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6);

  if (pasteData.length === 6) {
    const updatedDigits = pasteData.split('');
    setOtpDigits(updatedDigits);
    document.getElementById('otp-5').focus();
  }
};


const handleOtpKeyDown = (e, index) => {
  if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
    const updatedDigits = [...otpDigits];
    updatedDigits[index - 1] = "";
    setOtpDigits(updatedDigits);
    document.getElementById(`otp-${index - 1}`).focus();
  }
  if (e.key === "Enter") {
    // Only fire if all digits are filled and not verifying
    if (otp.length === 6 && !verifying) {
      verifyOTP();
    }
  }
};



const verifyOTP = async () => {
  setVerifying(true);
  setErrorMessage("");
  setSuccessMessage("");
  try {
      const csrfToken = document.cookie
          .split("; ")
          .find(row => row.startsWith("csrfToken="))
          ?.split("=")[1];

      if (!csrfToken) {
          setVerifying(false);
          setErrorMessage("Failed to verify 2FA due to security validation.");
          return;
      }

      const endpoint = twoFAType === "email" 
          ? "/api/2fa/verify-email-2fa" 
          : "/api/2fa/verify-2fa";

      const res = await axios.post(endpoint, { otp }, {
          withCredentials: true,
          headers: { "x-csrf-token": csrfToken }
      });

      setSuccessMessage("Two-Factor Authentication enabled successfully!");

      // Spinner can stay visible (since page reloads)
      if (twoFAType === "app") {
          navigate("/admin/user/backup-codes", {
              state: { backupCodes: res.data.backupCodes }
          });
      } else {
          setTimeout(() => window.location.reload(), 500);
      }
  } catch (error) {
      setVerifying(false); // Only hide spinner on error
      setErrorMessage(error.response?.data?.error || "Invalid OTP.");
  }
};


const handleResend = async () => {
  if (resendTimer > 0 || resending) return;
  setResending(true);
  setErrorMessage("");
  try {
    const csrfToken = document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];

    if (!csrfToken) throw new Error("Security validation failed");

    await axios.post("/api/2fa/send-2fa-email", {}, {
      withCredentials: true,
      headers: { "x-csrf-token": csrfToken }
    });

    setSuccessMessage("A new OTP has been sent to your email.");
    setResendTimer(30); // ← not setEmailResendTimer!
  } catch (err) {
    setErrorMessage(err.response?.data?.error || "Failed to resend code.");
  }
  setResending(false);
};



const regenerateBackupCodes = async () => {
  setRegeneratingBackup(true); // <-- Start spinner
  setErrorMessage("");
  setSuccessMessage("");

  try {
    const csrfToken = document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];

    if (!csrfToken) {
      setRegeneratingBackup(false);
      setErrorMessage("Failed to regenerate backup codes due to security validation.");
      return;
    }

    const res = await axios.post(
      "/api/2fa/regenerate-backup-codes",
      { password },
      {
        withCredentials: true,
        headers: { "x-csrf-token": csrfToken },
      }
    );

    if (res.data.backupCodes) {
      navigate("/admin/user/backup-codes", { state: { backupCodes: res.data.backupCodes } }); // ✅ Pass codes here
    }
  } catch (error) {
    setRegeneratingBackup(false); // <-- Stop spinner on error
    setErrorMessage(error.response?.data?.error || "Failed to regenerate backup codes.");
  }
};




  

const disable2FA = async () => {
  setDisabling(true); // Start spinner
  setErrorMessage("");
  setSuccessMessage("");
  try {
    if (!disable2FAPassword) {
      setDisabling(false);
      setErrorMessage("Password is required to disable 2FA.");
      return;
    }

    const csrfToken = document.cookie
      .split("; ")
      .find(row => row.startsWith("csrfToken="))
      ?.split("=")[1];

    if (!csrfToken) {
      setDisabling(false);
      setErrorMessage("Failed to disable 2FA due to security validation.");
      return;
    }

    await axios.post("/api/2fa/disable-2fa", { password: disable2FAPassword }, {
      withCredentials: true,
      headers: { "x-csrf-token": csrfToken }
    });

    setSuccessMessage("Two-Factor Authentication disabled.");
    setTimeout(() => window.location.reload(), 500);
  } catch (error) {
    setDisabling(false); // Only hide spinner on error
    setErrorMessage(error.response?.data?.error || "Failed to disable 2FA.");
  }
};





  return (
    <>
        <div className="two-factor-section">
            <h3>Two-Factor Authentication</h3>

            {!twoFactorEnabled ? (
            <>
                <div className="enable-2fa-wrapper">
                {twoFAType && (
                    <>
                    <label
                        className={`email-option ${twoFAType === "email" ? "selected" : ""}`}
                    >
                        <input
                        type="radio"
                        value="email"
                        checked={twoFAType === "email"}
                        onChange={(e) => auth.user.email && setTwoFAType(e.target.value)} // 🔐 prevent change if no email
                        disabled={!auth.user.email}
                        />
                        <i className="fa-solid fa-envelope"></i>
                        <span>
                        {auth.user.email
                            ? "Enable Email-Based 2FA"
                            : "Add an email to enable Email 2FA"}
                        </span>
                    </label>

                    <label className={twoFAType === "app" ? "selected" : ""}>
                        <input
                        type="radio"
                        value="app"
                        checked={twoFAType === "app"}
                        onChange={(e) => setTwoFAType(e.target.value)}
                        />
                        <i className="fa-solid fa-qrcode"></i>
                        <span>Enable Authenticator App 2FA</span>
                    </label>
                    </>
                )}
                </div>
                {twoFAType === "app" && !isAppOtpFlow && !enabling && (
                  <button
                    className="two-factor-button"
                    onClick={enable2FA}
                    disabled={enabling}
                  >
                    Enable 2FA
                  </button>
                )}

                {twoFAType === "email" && !isEmailOtpFlow && !enabling && (
                  <button
                    className="two-factor-button"
                    onClick={enable2FA}
                    disabled={enabling}
                  >
                    Enable 2FA
                  </button>
                )}

                {enabling && (
                  <button className="two-factor-button" disabled>
                    <div className="spinner"></div>
                  </button>
                )}



            </>
            ) : (
            <>
                <div className="enabled-2fa-icon">
                  <i className={`fa-solid ${twoFAType === "app" ? "fa-qrcode" : "fa-envelope"}`}></i>
                </div>
                <p className="enabled-2fa-message"><strong>2FA is enabled using: {twoFAType === "app" ? "Authenticator App" : "Email OTP"}</strong></p>
                            {twoFactorEnabled && twoFAType === "app" && (
                                <>
                                    {!showBackupRegeneration ? (
                                    <>
                                    <button className='regenerate-backup-codes' onClick={() => setShowBackupRegeneration(true)}>
                                        <i className="fa-solid fa-arrows-rotate"></i> Regenerate Backup Codes
                                    </button>
                                    </>
                                    ) : (
                                    <>
                                          <form
                                            onSubmit={(e) => {
                                              e.preventDefault();
                                              if (password) regenerateBackupCodes();
                                            }}
                                          >
                                            <input
                                              id="backup-password"
                                              type="password"
                                              value={password}
                                              onChange={(e) => setPassword(e.target.value)}
                                              placeholder="Enter your password"
                                              autoComplete="current-password"
                                            />
                                            <button type="submit" disabled={!password || regeneratingBackup}>
                                              {regeneratingBackup ? <div className="spinner"></div> : "Confirm & Generate New Codes"}
                                            </button>

                                          </form>

                                    </>
                                    )}
                                </>
                              )}
                  {!showDisable2FAPasswordField ? (
                    <>
                      <button className="disable-2fa-button" onClick={() => setShowDisable2FAPasswordField(true)}>
                        <i className="fa-solid fa-user-slash"></i> Disable 2FA
                      </button>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          color: "#dc3545",
                          fontSize: "0.95em",
                          marginBottom: '10px'
                        }}
                      >
                        <i className="fa-solid fa-triangle-exclamation" style={{fontSize: "1.12em"}}></i>
                        &nbsp;
                        <span>
                          Disabling 2FA can leave your account vulnerable if your password is weak or compromised.
                        </span>
                      </div>
                      <form
                        className="disable-2fa-confirm"
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (disable2FAPassword && !disabling) disable2FA();
                        }}
                      >
                        <input
                          id="disable-2fa-password"
                          type="password"
                          value={disable2FAPassword}
                          onChange={(e) => setDisable2FAPassword(e.target.value)}
                          placeholder="Enter your password"
                          autoComplete="current-password"
                        />

                        <button
                          type="submit"
                          disabled={!disable2FAPassword || disabling}
                        >
                          {disabling ? <div className="spinner"></div> : "Confirm & Disable 2FA"}
                        </button>
                      </form>
                    </>
                  )}

            </>
            )}
            

            {isEmailOtpFlow && (
  <div className="verify-2fa-wrapper">
    {/* Email OTP UI */}
    <p style={{ marginBottom: "0px", fontWeight: 500 }}>
      Check your email for a one-time code to continue.
    </p>
    <p
      style={{
        fontSize: "0.85em",
        marginTop: "-5px",
        color: "#adb5bd",
        fontWeight: 400
      }}
    >
      If you don&apos;t see the email, check your spam or junk folder.
    </p>
    <div style={{ marginTop: 12, marginBottom: 4, display: "flex", alignItems: "center", gap: 10 }}>
      <button
        className="resend-otp-btn"
        onClick={handleResend}
        disabled={resendTimer > 0 || resending}
        style={{
          fontSize: "0.97em",
          padding: "3px 12px",
          opacity: resendTimer > 0 || resending ? 0.65 : 1,
          pointerEvents: resendTimer > 0 || resending ? "none" : "auto"
        }}
        type="button"
      >
        {resending ? <div className="spinner" /> : "Resend code"}
      </button>
      {resendTimer > 0 && (
        <span style={{ fontSize: "0.94em", color: "#888" }}>
          {`Resend available in ${resendTimer}s`}
        </span>
      )}
    </div>
    <div className="otp-container" onPaste={handleOtpPaste}>
      <div className="otp-boxes-wrapper">
        {otpDigits.map((digit, index) => (
          <input
            key={index}
            id={`otp-${index}`}
            type="text"
            inputMode="numeric"
            maxLength="1"
            value={digit}
            onChange={(e) => handleOtpChange(e.target.value, index)}
            onKeyDown={(e) => handleOtpKeyDown(e, index)}
            className="otp-box"
            disabled={verifying}
          />
        ))}
      </div>
    </div>
    <button
      onClick={verifyOTP}
      disabled={otp.length !== 6 || verifying}
      style={{margin: '0'}}
    >
      {verifying ? <div className="spinner"></div> : "Verify OTP"}
    </button>
    {verifying && (
      <p style={{ marginTop: 12, fontWeight: 500 }}>Verifying...</p>
    )}
  </div>
)}

{isAppOtpFlow && (
  <div className="verify-2fa-wrapper">
    {/* App-based 2FA UI */}
    <p>Scan this QR Code with your Authenticator App:</p>
    <img src={appQrCode} alt="2FA QR Code" />
    <p>Or enter this code manually in your app: <strong>{secret}</strong></p>
    <div className="otp-container" onPaste={handleOtpPaste}>
      <div className="otp-boxes-wrapper">
        {otpDigits.map((digit, index) => (
          <input
            key={index}
            id={`otp-${index}`}
            type="text"
            inputMode="numeric"
            maxLength="1"
            value={digit}
            onChange={(e) => handleOtpChange(e.target.value, index)}
            onKeyDown={(e) => handleOtpKeyDown(e, index)}
            className="otp-box"
            disabled={verifying}
          />
        ))}
      </div>
    </div>
    <button
      onClick={verifyOTP}
      disabled={otp.length !== 6 || verifying}
      style={{margin: '0'}}
    >
      {verifying ? <div className="spinner"></div> : "Verify OTP"}
    </button>
    {verifying && (
      <p style={{ marginTop: 12, fontWeight: 500 }}>Verifying...</p>
    )}
  </div>
)}




        </div>
    </>
  );
};

export default UserTwoFactor;